module.exports = __webpack_public_path__ + "src/content/pdf/CV_Maxim_Schoemaker_2024.pdf";